<script setup lang="ts"></script>

<template>
	<strong class="block text-2xl font-black">
		<slot />
	</strong>
</template>

<style scoped></style>
